export default "__VITE_ASSET__DYNUZS7A__"